module.exports = __webpack_public_path__ + "img/Diagram3p3.a29499fd.svg";